<template>
  <div>
    <Spin size="large" v-if="loading" class="spin"></Spin>
    <BackTop :bottom="20" :right="20" :height="200"></BackTop>
    <Row class="mobile-title">
      <Col span="4">
        <a style="margin-left: 0.5rem" @click="backPrev">
          <Icon type="ios-arrow-back" />
        </a>
      </Col>
      <Col span="16" style="text-align: center">销控台</Col>
    </Row>
    <div style="padding: 1rem 1rem 0 1rem; margin-top: 37px">
      <Select v-model="projectFid" class="select-width mb16" placeholder="请选择项目" @on-change="fetchData">
        <Option v-for="(item, index) in projectBuildList" :key="'project' + index" :value="item.value">{{item.text}}</Option>
      </Select>
    </div>
    <div>
      <div style="padding: 0 1rem 1rem 1rem; font-size: 1.5rem">
        <Icon type="ios-home-outline" /> {{ overviewData.totalStCountStr }}
      </div>
      <!-- 已出租 -->
      <div class="mobile-card">
        <div class="mobile-card-title">
          <Icon type="ios-checkmark-outline" /> {{ overviewData.yczStCountStr }}
        </div>
        <Tag v-for="(item, index) in overviewData.yczHouseTypeCountStr" :key="index" type="border" color="green">
          {{ item }}
        </Tag>
        <div v-if="notHaveYCX" style="color: #bbbec4; text-align: center;">暂无数据</div>
      </div>

      <!-- 已预定 -->
      <div class="mobile-card">
        <div class="mobile-card-title">
          <Icon type="ios-cart-outline"></Icon> {{ overviewData.yydStCountStr }}
        </div>
        <Tag v-for="(item, index) in overviewData.yydHouseTypeCountStr" :key="index" type="border" color="#91d5ff">
          {{ item }}
        </Tag>
        <div v-if="notHaveYYD" style="color: #bbbec4; text-align: center;">暂无数据</div>
      </div>

      <!-- 未出租 -->
      <div class="mobile-card">
        <div class="mobile-card-title">
          <Icon type="ios-information-outline" /> {{ overviewData.wczStCountStr }}
        </div>
        <Tag v-for="(item, index) in overviewData.wczHouseTypeCountStr" :key="index" type="border" color="yellow">
          {{ item }}
        </Tag>
        <div v-if="notHaveWCX" style="color: #bbbec4; text-align: center;">暂无数据</div>
      </div>
      <div style="height: 30px; line-height: 30px; background-color: #f8f8f9; text-align: center">
        <Icon type="arrow-down-b" /> 下面显示空置房间 (浅蓝色为已预订)
      </div>
      <Tabs size="small" :animated="false" v-model="building" @on-click="getRoomData">
        <TabPane v-for="(item, index) in buildings" :key="index" :label="item.text" :name="item.value"></TabPane>
      </Tabs>
      <div v-if="!rooms.length" style="text-align: center; color: #bbbec4">暂无空置房间</div>
      <div v-else style="padding: 1rem">
        <floor-card v-for="(item, index) in rooms" :key="index" :floor="item" style="margin-bottom: 0.8rem"></floor-card>
      </div>
    </div>
  </div>
</template>

<script>
  import floorCard from './components/floorCard'
  import { getBuildInfo } from '../../api/ladder.js';
  import { marketingCtrlOverView, marketingCtrlVacant } from "../../api/outHouse";
  export default {
    name: "index",
    components: {
      floorCard
    },
    data () {
      return {
        projectBuildList: [],
        projectFid: '',
        overviewData: {},
        building: '',
        buildings: [],
        rooms: [],
        loading: false
      }
    },
    computed: {
      notHaveYCX () {
        return !this.overviewData.yczHouseTypeCountStr || !this.overviewData.yczHouseTypeCountStr.length
      },
      notHaveYYD () {
        return !this.overviewData.yydHouseTypeCountStr || !this.overviewData.yydHouseTypeCountStr.length
      },
      notHaveWCX () {
        return !this.overviewData.wczHouseTypeCountStr || !this.overviewData.wczHouseTypeCountStr.length
      }
    },
    methods: {
      backPrev () {
        this.$router.go(-1)
      },
      fetchData (val) {
        this.rooms = []
        this.getOverview()
        let projectBuild = this.projectBuildList.find(x => x.value === val)
        if (projectBuild) {
          this.buildings = projectBuild.children
        } else {
          this.buildings = []
        }
        if (this.buildings.length) {
          this.building = this.buildings[0].value
          this.getRoomData(this.building)
        } else {
          this.building = ''
        }
      },
      getOverview () {
        this.loading = true
        marketingCtrlOverView(this.projectFid).then(res => {
          this.overviewData = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },
      getRoomData (name) {
        this.loading = true
        marketingCtrlVacant(name).then(res => {
          this.rooms = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      }
    },
    created() {
      this.projectFid = this.$route.params.id
      getBuildInfo().then(res => {
        this.projectBuildList = res.data
        this.fetchData(this.projectFid)
      })
    }

  }
</script>

<style scoped lang="less">

  .mobile-title {
    border-bottom: 1px solid #e8eaec;
    font-size: 2rem;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 2;
    background-color: #ffffff;
  }

  .mobile-card {
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 6px;
    border: 1px solid #e9eaec;
    .mobile-card-title {
      border-bottom: 1px solid #e9eaec;
      padding: 0.3rem;
      margin-bottom: 0.3rem;
    }
  }
</style>
